import { Head, Banner, Contact } from "../components/Project";
import { Grid, Space, Table, QA } from "../components/Layout";
import { Title, Texts, Media } from "../components/Object";
import { useParams } from "react-router-dom";
import { VoiceList } from "../components/Post";

const Voice = () => {

  const args = {
    page: 1,
    type: "voice",
    perPage: 5,
  };

  return (
    <>
      <Head slug="voice" type="noimage"></Head>
      <div className="l-row">
        <Texts slug={`title/voice`} class={'c-text--en c-text--big c-text--main'} />
        <Space size={['24px 0 64px', '24px 0 48px']}>
          <Texts slug={`voice/title`} class={''} />
        </Space>
      </div>

      <div className="p-box__wrap--about" data-state="voice">
        <VoiceList {...args} />
        <Space size={['120px', '80px']}></Space>
      </div>
      <Space size={['160px', '100px']}></Space>

      <div id="faq" className="l-row">
        <div className="c-grid__wrap--table">
          <div>
            <Texts slug={`title/qa`} class={'c-text--main c-text--big c-text--en'} />
            <Space size={['64px 0 0', '48px 0 0']}>
              <Texts slug={`qa/title`} class={''} />
            </Space>
          </div>

          <QA length={7} slug="qa"></QA>
        </div>
      </div>
      <Space size={['200px', '120px']}></Space>
    </>
  );
};

export default Voice;